import { styled } from '@stitches/configed';
import { Select, Space, Tooltip } from 'antd';
import { ShopOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from '../../../store';
import { useLocation, useNavigate } from 'react-router-dom';
import { AddStoreIcon } from '@you-go-vn/components';
import { setCurrentRestaurant } from '../slice';

const Container = styled('div', {
  lineHeight: 1,
  cursor: 'pointer',
  maxWidth: 250,
  borderRadius: 6,
  border: '1px solid $border',
  display: 'flex',
  alignItems: 'center',
  padding: '8px 14px',
});
const Icon = styled('span', {
  marginRight: 8,
  '&>svg': {
    fontSize: 20,
  },
});
const Title = styled('div', {
  maxWidth: 180,
  fontWeight: 600,
  fontSize: 14,
  whiteSpace: 'normal',
  variants: {
    ellipsis: {
      true: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
      },
    },
  },
});
const State = styled('div', {
  marginTop: 4,
  fontSize: 12,
  color: '#D33C0C',
  variants: {
    active: {
      true: {
        color: '#17AFA7',
      },
    },
  },
});
const AddIconStyled = styled('span', {
  svg: {
    color: '$brand',
    fontSize: 40,
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.05)',
    },
  },
});

const RestaurantSelector = () => {
  const dispath = useAppDispatch();

  const { restaurants, currentRestaurant } = useAppSelector((state) => state.restaurant);
  return (
    <Space>
      {!restaurants || restaurants.length === 0 ? (
        <>
          <Container>
            <Icon>
              <ShopOutlined />
            </Icon>
            <div>
              <Title>Chưa có nhà hàng nào</Title>
              <State>Vui lòng thêm ít nhất một nhà hàng</State>
            </div>
          </Container>
        </>
      ) : (
        <Select
          className="restaurant-selector"
          style={{ minWidth: 200 }}
          defaultValue={currentRestaurant?.id}
          optionLabelProp="label"
          onChange={(value) => {
            const selected = restaurants.find((x) => x.id === value);
            if (selected) {
              dispath(setCurrentRestaurant(selected));
            }
          }}
        >
          {restaurants.map((item) => (
            <Select.Option
              key={item.id}
              value={item?.id}
              label={
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '6px 0',
                  }}
                >
                  <ShopOutlined style={{ marginRight: 8, fontSize: 20 }} />
                  <div>
                    <Title ellipsis>{item?.name}</Title>
                    <State active={item?.status === 'active'}>
                      {item?.status === 'active' ? 'Đã kích hoạt' : 'Chưa kích hoạt'}
                    </State>
                  </div>
                </div>
              }
            >
              <div>
                <Title ellipsis>{item?.name}</Title>
                <State active={item?.status === 'active'}>
                  {item?.status === 'active' ? 'Đã kích hoạt' : 'Chưa kích hoạt'}
                </State>
              </div>
            </Select.Option>
          ))}
        </Select>
      )}
    </Space>
  );
};

export default RestaurantSelector;
